export default {
  workshop: {
    breadcrumbHome: 'Inicio',
    breadcrumbSolutions: 'Soluciones',
    breadcrumbCurrent: 'Taller e industria',
    hero: {
      eyebrow: 'Taller e industria',
      title: 'Tecnología de seguridad robusta para entornos exigentes',
      lead: 'Polvo, humedad, cambios de temperatura: los talleres exigen mucho. Montamos cámaras que aguantan.',
    },
    areas: {
      title: 'Áreas de uso en talleres e industria',
      lead: 'Del área de taller al patio exterior: aseguramos sus valiosas herramientas, máquinas y vehículos.',
      items: {
        '0': { title: 'Nave de taller', desc: 'Las naves altas con máquinas necesitan cámaras robustas con buena resolución, incluso con luz difícil.' },
        '1': { title: 'Área de taller', desc: 'Herramientas, repuestos y trabajos en curso: la vigilancia protege su espacio y aclara reclamaciones.' },
        '2': { title: 'Zona de carga', desc: 'Carga y descarga son ventanas para el robo. Las cámaras de la zona documentan cada operación.' },
        '3': { title: 'Zona de máquinas', desc: 'La fabricación moderna exige documentación completa del proceso, incluso entre máquinas.' },
        '4': { title: 'Patio y aparcamiento', desc: 'Vehículos, remolques y material: el patio necesita cámaras resistentes con buena visión nocturna.' },
        '5': { title: 'Oficina y administración', desc: 'Ofertas, facturas y datos de clientes están en la oficina. Aquí tampoco se descuida la seguridad.' },
      },
    },
    robust: {
      eyebrow: 'Robustez',
      title: 'Construido para el uso exigente',
      lead: 'Los talleres no son salas de exposición. Nuestras cámaras están hechas para estos entornos y se eligen para sus condiciones.',
      items: {
        '0': { title: 'Alta clase de protección', desc: 'Carcasas IP66 protegen de polvo, salpicaduras y lluvia, incluso en exterior continuo.' },
        '1': { title: 'Resistente a temperatura y humedad', desc: 'De almacén helado a taller cálido: elegimos cámaras para cada rango de temperatura.' },
        '2': { title: 'Carcasas antipolvo', desc: 'En entornos polvorientos, carcasas y juntas especiales mantienen la óptica limpia y nítida durante años.' },
      },
    },
    maintenance: {
      eyebrow: 'Mantenimiento y soporte',
      title: 'Para que su sistema siga siendo fiable',
      lead: 'En entornos polvorientos y exigentes, el cuidado decide la vida útil. Con SSG Care su sistema sigue siempre listo.',
      list: {
        '0': 'Revisiones regulares de SSG Care, incluso fuera de garantía',
        '1': 'Limpieza e inspección visual de carcasa y objetivo',
        '2': 'Actualizaciones de firmware y seguridad según necesidad',
        '3': 'Respuesta rápida ante fallos',
        '4': 'Opciones de repuestos y mejora para su sistema',
      },
      note: 'Nota: la legalidad de la videovigilancia depende del caso concreto. Le asesoramos, sin sustituir el asesoramiento jurídico.',
    },
    cta: {
      title: 'Su taller merece una mirada segura',
      lead: 'Le asesoramos sin compromiso sobre qué cámaras aguanta su entorno y dónde protegen más.',
      primary: 'Concertar una cita de asesoría',
      secondary: 'Descubrir SSG Care',
    },
  },
};